import React, { Children } from 'react';
import { ArrowLeft } from 'lucide-react';
interface PrivacyPageProps {
  setCurrentPage: (page: 'home' | 'terms' | 'privacy') => void;
}
export function PrivacyPage({
  setCurrentPage
}: PrivacyPageProps) {
  const handleBack = () => {
    setCurrentPage('home');
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-warm-white py-12 px-6" data-id="element-317">
      <div className="max-w-3xl mx-auto" data-id="element-318">
        <button onClick={handleBack} className="flex items-center gap-2 text-navy font-medium mb-8 hover:text-teal transition-colors" data-id="element-319">
          <ArrowLeft className="w-4 h-4" data-id="element-320" />
          Back to Home
        </button>

        <div className="bg-white p-8 md:p-12 rounded-xl shadow-sm border border-soft-sage/30" data-id="element-321">
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-2" data-id="element-322">
            Privacy Policy
          </h1>
          <p className="text-muted mb-8" data-id="element-323">Last Updated: February 14, 2026</p>

          <div className="space-y-8 text-body leading-relaxed" data-id="element-324">
            <section data-id="element-325">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-326">1. Overview</h2>
              <p data-id="element-327">
                Better By Steps LLC ("we," "us," or "our") respects your privacy
                and is committed to protecting your personal data. This privacy
                policy will inform you as to how we look after your personal
                data when you visit our website or purchase our products.
              </p>
            </section>

            <section data-id="element-328">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-329">
                2. Information We Collect
              </h2>
              <p data-id="element-330">
                We collect information you provide directly to us, such as when
                you make a purchase or contact us for support. This may include:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-331">
                <li data-id="element-332">Contact information (name, email address)</li>
                <li data-id="element-333">
                  Transaction information (purchase details, date, amount)
                </li>
                <li data-id="element-334">
                  Payment information (processed securely by our payment
                  processors; we do not store full credit card numbers)
                </li>
              </ul>
              <p className="mt-2 text-sm italic text-muted" data-id="element-335">
                Note: We do NOT collect or store any medical information you
                enter into your personal binder. The binder is a PDF file that
                lives on your device or in printed form.
              </p>
            </section>

            <section data-id="element-336">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-337">
                3. How We Use Your Information
              </h2>
              <p data-id="element-338">We use the information we collect to:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-339">
                <li data-id="element-340">
                  Process your transactions and deliver your digital products
                </li>
                <li data-id="element-341">Send you transaction receipts and download links</li>
                <li data-id="element-342">Respond to your comments and questions</li>
                <li data-id="element-343">
                  Send you related information, including updates and support
                  messages
                </li>
                <li data-id="element-344">
                  Monitor and analyze trends, usage, and activities in
                  connection with our services
                </li>
              </ul>
            </section>

            <section data-id="element-345">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-346">
                4. Third-Party Services
              </h2>
              <p data-id="element-347">
                We use trusted third-party services to operate our business,
                including:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-348">
                <li data-id="element-349">
                  <strong data-id="element-350">Shopify / Stripe:</strong> For secure payment
                  processing
                </li>
                <li data-id="element-351">
                  <strong data-id="element-352">Email Service Providers:</strong> To deliver your
                  product and updates
                </li>
                <li data-id="element-353">
                  <strong data-id="element-354">Analytics:</strong> To understand how visitors use our
                  site (e.g., Google Analytics)
                </li>
              </ul>
            </section>

            <section data-id="element-355">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-356">5. Cookies</h2>
              <p data-id="element-357">
                We use cookies and similar tracking technologies to track the
                activity on our service and hold certain information. You can
                instruct your browser to refuse all cookies or to indicate when
                a cookie is being sent.
              </p>
            </section>

            <section data-id="element-358">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-359">
                6. Your Rights
              </h2>
              <p data-id="element-360">
                Depending on your location, you may have rights regarding your
                personal data, including the right to access, correct, or delete
                your personal data. To exercise these rights, please contact us
                at hello@betterbysteps.com.
              </p>
            </section>

            <section data-id="element-361">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-362">
                7. Children's Privacy
              </h2>
              <p data-id="element-363">
                Our services are not intended for use by children under the age
                of 13. We do not knowingly collect personal data from children.
              </p>
            </section>

            <section data-id="element-364">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-365">
                8. Data Security
              </h2>
              <p data-id="element-366">
                We have implemented appropriate security measures to prevent
                your personal data from being accidentally lost, used, or
                accessed in an unauthorized way.
              </p>
            </section>

            <section data-id="element-367">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-368">
                9. Contact Us
              </h2>
              <p data-id="element-369">
                If you have any questions about this Privacy Policy, please
                contact us at hello@betterbysteps.com.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>;
}